import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdClassNotionalpoolingService {
  static async entityAttrList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassNotionalpooling?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getClassAttributeValue(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassNotionalpooling/get_class_attribute_value?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async create(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassNotionalpooling', payload)
    )
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance('/api/std/StdClassNotionalpooling', {
        method: 'delete',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async getReferenceClass(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassNotionalpooling/get_reference_class?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async saveRelation(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassNotionalpoolingRelation/save_relation', payload)
    )
    return Callback(err, res)
  }
}
